import _memoize from 'lodash/memoize';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../../../../utils/style';

export { getHeight } from '../blockHeader/blockHeader.style';

export const defaultContext = makeDefaultStylingContext();

export const GAP = {
  [HD]: 32,
  [FULL_HD]: 40,
};

export const getInitialStyle = _memoize(() => ({
  Container: {
    flex: {
      direction: 'row',
    },
  },
}));

export const getTabStyle = _memoize(screenSize => ({
  flexItem: {
    marginRight: GAP[screenSize],
  },
}));
